import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { UploadModal } from "../Popup/UploadModal";
import {
  AllMenu,
  DownloadBtn,
  ListItem,
  MenuLink,
  SpanTitle,
} from "../../styles/Sidebar/Menu.styled";
import { docsFilter } from "../../actions/filter";
import { NavLink, useParams } from "react-router-dom";

import {
  Incoming,
  Outcoming,
  AllDocs,
  Settings,
  External,
  DocumentsIcon,
  ArchiveUploadIcon,
  Contact
} from "../../../public/icons/index";
import { createPortal } from "react-dom";

const elements = [
    {
    title: "Всі документи",
    type: "all",
    icon: (color: string) => <AllDocs color={color} />,
  },
  {
    title: "Зовнішні документи",
    type: "external",
    icon: (color: string) => <External color={color} />,
  },
  {
    title: "Внутрішні документи",
    type: "internal",
    icon: (color: string) => <DocumentsIcon color={color} />,
  },
  {
    title: "Вхідні документи",
    type: "incoming",
    icon: (color: string) => <Incoming color={color} />,
  },
  {
    title: "Вихідні документи",
    type: "outgoing",
    icon: (color: string) => <Outcoming color={color} />,
  },
  {
    title: "Архів",
    type: "archived",
    icon: (color: string) => <ArchiveUploadIcon color={color} size={20} />,
  },
          {
      title: "Контакти контрагентів",
      type: "contacts",
          icon: (color: string) => <Contact color={color} size={20} />,
      },
  {
    title: "Налаштування акаунту",
    type: "account",
    path: "/settings/account",
    icon: (color: string) => <Settings color={color} />,
  },

  {
    title: "Налаштування компанії",
    type: "settings",
    icon: (color: string) => <Settings color={color} />,
    submenu: [
      {
        title: "Атрибути документів",
        type: "settings/attributes",
        permission: ["attribute.create", "attribute.update"],
      },
      {
        title: "Типи документів",
        type: "settings/document-type",
        permission: ["document-type.create", "document-type.update"],
      }
    ],
  }
];


export default function Menu() {
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState<number | null>(null);

  const params = useParams();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const auth = useAppSelector((state) => state.auth);


  //  console.log("Menu", user)

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const hasPermission = (action: string) => !!user.permissions?.[action];

  const filteredElements = !user.permissions
    ? elements.filter((el) => el.type !== "general")
    : elements;

  useEffect(() => {
    dispatch(docsFilter(params.type ?? ""));
  }, [params.type, auth]);

  return (
    <AllMenu>
      <DownloadBtn type="button" onClick={handleOpen}>
        Завантажити
      </DownloadBtn>

      {filteredElements.map((el, i) => {
        const hasSubmenu = el.submenu && el.submenu.length > 0;

        if (hasSubmenu) {
          const filteredSubmenu = el.submenu.filter(
            (sub) =>
              !sub.permission || sub.permission.some((p) => hasPermission(p)),
          );

          if (filteredSubmenu.length === 0) return null;

          return (
            <ListItem key={i}>
              <NavLink to={`/${el.type}/`} end>
                {({ isActive }) => (
                  <MenuLink
                    $active={isActive ? "active" : ""}
                    onMouseEnter={() => setHover(i)}
                    onMouseLeave={() => setHover(null)}
                  >
                    {el.icon &&
                      el.icon(hover === i ? "var(--blue)" : "var(--black)")}
                    <SpanTitle
                      style={{
                        color: hover === i ? "var(--blue)" : undefined,
                      }}
                    >
                      {el.title}
                    </SpanTitle>
                  </MenuLink>
                )}
              </NavLink>

              <ul style={{ paddingLeft: "20px", marginTop: "4px", fontSize: "12px"}}>
                {filteredSubmenu.map((sub, j) => (
                  <ListItem key={j}>
                    <NavLink to={`/${sub.type}`} end >
                      {({ isActive }) => (
                        <MenuLink $active={isActive ? "active" : ""}>
                          <SpanTitle style={{ fontSize: "13px"}}>{sub.title}</SpanTitle>
                        </MenuLink>
                      )}
                    </NavLink>
                  </ListItem>
                ))}
              </ul>
            </ListItem>
          );
        }
        return (
          <ListItem
            key={i}
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(null)}
          >
            <NavLink to={el.path ?? `/documents/${el.type}`} end>
              {({ isActive }) => (
                <MenuLink $active={isActive ? "active" : ""}>
                  {el.icon &&
                    el.icon(
                      isActive || hover === i ? "var(--blue)" : "var(--black)",
                    )}
                  <SpanTitle>{el.title}</SpanTitle>
                </MenuLink>
              )}
            </NavLink>
          </ListItem>
        );
      })}

      {open &&
        createPortal(<UploadModal handleClose={handleClose} />, document.body)}
    </AllMenu>
  );
}
